module.exports = {
      id: "movie-icon-usage",
      viewBox: "0 0 16 19",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#movie-icon",
      toString: function () {
        return this.url;
      }
    }